import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/solid";
import { useState } from "react";

export default function CollapsibleSection({
  title,
  startOpen = true,
  children,
}) {
  const [isOpen, setIsOpen] = useState(startOpen);

  return (
    <div className="pb-2">
      <h4
        className="flex justify-between px-4 py-2 font-semibold bg-primaryColor cursor-pointer"
        onClick={() => setIsOpen((x) => !x)}
      >
        {title}
        {isOpen ? (
          <ChevronDownIcon className="w-5 cursor-pointer" />
        ) : (
          <ChevronUpIcon className="w-5 cursor-pointer" />
        )}
      </h4>
      {isOpen && children}
    </div>
  );
}
